import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Style/typo.css";
import "./assets/css/style-video.css";
import NavButton from "../homepage/header-banner/TopNavButton";
import Footer from "../homepage/footer/Footer";
import DeskIcon1 from "./assets/image/desk_icon1.png";
import DeskIcon2 from "./assets/image/desk_icon2.png";
import DeskIcon3 from "./assets/image/desk_icon3.png";
// import DeskIcon4 from "./assets/image/desk_icon4.png";
// import DeskIcon5 from "./assets/image/desk_icon5.png";
import DeskIcon6 from "./assets/image/desk_icon6.png";
import DeskIcon7 from "./assets/image/desk_icon7.png";
import VideoImg from "./assets/image/video-img.png";
import VideoFeatureImg1 from "./assets/image/video-feature-img1.png";
import VideoImage from "./assets/image/video-image.png";
import VideoImage1 from "./assets/image/video-image1.png";
import VideoImage2 from "./assets/image/video-image2.png";
import VideoImage3 from "./assets/image/video-image3.png";
// import VideoFeatureImg2 from "./assets/image/video-feature-img2.png";
// import VideoFeatureImg3 from "./assets/image/video-feature-img3.png";
import FadeInSection from "../container/component/Fadeanimation/FadeInSection";

export function VideoBanner() {
    const scrollToSection = (id, offset = 80) => {
        const el = document.getElementById(id);
        if (!el) return;
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: "smooth" });
    };

    return (
        <div className="video">
            <div className="video-banner">
                <div className="fit-video-box">
                    <FadeInSection>
                        <div className="video-wrap">
                            <div className="video-box video-box-left">
                                <div className="video-banner-left">
                                    <div>
                                        <p className="typo-32-mb wh-color">소통과 협업을 이끌어 내는 한비로 Talk</p>
                                        <p className="typo-16 wh-color">
                                            언제, 어디서나 장소의 구애없이 편리하게 업무를 처리하는 한비로 Talk!
                                            <br />
                                            여러분 기업만의 폐쇄형 커뮤니케이션 공간으로 업무 집중도를 향상시켜 보세요!
                                            <br />
                                            한비로 Talk은 직원들과의 커뮤니케이션을 증진 시키는 스마트한 플랫폼 입니다!
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="video-box video-box-right">
                                <div className="video-box-img">
                                    <img src="https://hanbiro.com/assets/images/cloud/video-conference-banner-sm.png" alt="video1" />
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>
        </div>
    );
}

export function VideoBody() {
    return (
        <div>
            <div className="video-block video-ft-block">
                <div className="fit-video-box">
                    <FadeInSection>
                        <div className="video-feature">
                            <div className="video-title-feature">
                                <p className="typo-32 typo-medium">AI Features</p>
                            </div>

                            <div className="video-feature-block video-feature-block-item">
                                <div className="video-feature-box">
                                    <div className="video-feature-img">
                                        <img src={VideoFeatureImg1} alt="" />
                                    </div>
                                    <div className="video-feature-text">
                                        <p className="typo-16 typo-medium">원격지</p>
                                        <p className="typo-16 video-desc">상대방의 PC 화면을 원격으로 확인하고 직접 조작</p>
                                    </div>
                                </div>
                                <div className="video-feature-box">
                                    <div className="video-feature-img">
                                        <img src={VideoFeatureImg1} alt="" />
                                    </div>
                                    <div className="video-feature-text">
                                        <p className="typo-16 typo-medium">AI 요약: 번역</p>
                                        <p className="typo-16 video-desc">메신저 대화 내용 요약 및 번역</p>
                                    </div>
                                </div>
                                <div className="video-feature-box">
                                    <div className="video-feature-img">
                                        <img src={VideoFeatureImg1} alt="" />
                                    </div>
                                    <div className="video-feature-text">
                                        <p className="typo-16 typo-medium">AI 화상회의 요약음성 텍스트 변</p>
                                        <p className="typo-16 video-desc">화상회의 대화 내용 요약 화상회의 대화 내용을 음성 텍스트 변환</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>

            <div className="video-block" id="video-ai-feature">
                <div className="fit-video-box">
                    <div className="video-feature">
                        <div className="video-title">
                            <p className="typo-32 typo-medium">AI 전화 기능</p>
                        </div>
                        <FadeInSection>
                            <div className="video-content">
                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">원격지</p>
                                            <p className="typo-16 video-desc video-desc-content">
                                                eque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore
                                                et dolore magnam aliquam quaerat voluptatem.
                                            </p>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-main-screen.png" />
                                        </div>
                                    </div>
                                </div>

                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">전화 이력 관리 화면</p>
                                            <p className="typo-16 video-desc video-desc-content">
                                                eque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore
                                                et dolore magnam aliquam quaerat voluptatem.
                                            </p>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-video-conference.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>

                        <FadeInSection>
                            <div className="video-content ">
                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">원격지</p>
                                            <p className="typo-16 video-desc video-desc-content">
                                                eque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore
                                                et dolore magnam aliquam quaerat voluptatem.
                                            </p>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-screen-sharing.png" />
                                        </div>
                                    </div>
                                </div>

                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">전화 이력 관리 화면</p>
                                            <p className="typo-16 video-desc video-desc-content">
                                                eque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore
                                                et dolore magnam aliquam quaerat voluptatem.
                                            </p>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-ai.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>

                        <FadeInSection>
                            <div className="video-content">
                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">원격지</p>
                                            <p className="typo-16 video-desc video-desc-content">
                                                eque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore
                                                et dolore magnam aliquam quaerat voluptatem.
                                            </p>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-conference-invite-guest.png" />
                                        </div>
                                    </div>
                                </div>

                                <div className="video-item">
                                    <div className="video-item-content">
                                        <div className="video-item-icon">
                                            <p className="typo-21 typo-medium">전화 이력 관리 화면</p>
                                            <p className="typo-16 video-desc video-desc-content">
                                                eque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore
                                                et dolore magnam aliquam quaerat voluptatem.
                                            </p>
                                        </div>
                                        <div className="video-item-img">
                                            <img src="https://hanbiro.com/assets/images/cloud/video-conference-demo/demo-meeting-notes.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FadeInSection>
                    </div>
                </div>
            </div>

            <div className="video-block" id="video-key-feature">
                <div className="fit-video-box">
                    <FadeInSection>
                        <div className="video-feature">
                            <div className="video-title">
                                <p className="typo-32 typo-medium">화상회의 특장점</p>
                            </div>
                            <div className="video-feature-wrap">
                                <div className="video-feature-block">
                                    <div className="video-feature-box">
                                        <div className="video-feature-img">
                                            <img src={VideoFeatureImg1} alt="" />
                                        </div>
                                        <div className="video-feature-text">
                                            <p className="typo-16 typo-medium">누구나 쉽게 생성</p>
                                            <p className="typo-16 video-desc">메신저 대화방에서 클릭 한 번으로 생성</p>
                                        </div>
                                    </div>
                                    <div className="video-feature-box">
                                        <div className="video-feature-img">
                                            <img src={VideoImage1} alt="" />
                                        </div>
                                        <div className="video-feature-text">
                                            <p className="typo-16 typo-medium">메신저 대화방에서 클릭 한 번으로 생성</p>
                                            <p className="typo-16 video-desc">웹 기반으로 별도의 설치 프로그램 없이 외부 사용자도 클릭 한 번으로</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="video-feature-block">
                                    <div className="video-feature-box">
                                        <div className="video-feature-img">
                                            <img src={VideoImage2} alt="" />
                                        </div>
                                        <div className="video-feature-text">
                                            <p className="typo-16 typo-medium">실시간 화면 공유</p>
                                            <p className="typo-16 video-desc">PC화면 공유로 프리젠테이션이나 원격 교육 가능</p>
                                        </div>
                                    </div>
                                    <div className="video-feature-box">
                                        <div className="video-feature-img">
                                            <img src={VideoImage3} alt="" />
                                        </div>
                                        <div className="video-feature-text">
                                            <p className="typo-16 typo-medium">모바일 지원</p>
                                            <p className="typo-16 video-desc">모바일 기기에서도 화상회의 참석 가능</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeInSection>
                </div>
            </div>
        </div>
    );
}

export function VideoContent() {
    return (
        <>
            <VideoBanner />
            <VideoBody />
        </>
    );
}

function VideoConference() {
    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            <VideoContent />
            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default VideoConference;
